import { Pipe, PipeTransform } from '@angular/core';
import * as removeAccents from 'remove-accents';

@Pipe({
  name: 'modalFilterColaboradorPeriodo'
})
export class ModalFilterColaboradorPeriodoPipe implements PipeTransform {

  transform(value: any, filtroPesquisa?: string, filtroCodigo?: string, filtroNome?: string, filtroCPF?: string, filtroMatricula?: string,
    filtroAplicativo?: string, alterado?: boolean): any {

      let resultFilter = value;
      if (!filtroPesquisa && !filtroCodigo && !filtroNome && !filtroCPF && !filtroMatricula &&
         !filtroAplicativo) {
          return resultFilter;
        } else {
          if (filtroCodigo) {
            resultFilter = resultFilter.filter(s => s.colaboradorId.toLocaleString().toLocaleLowerCase().includes(filtroCodigo.toLocaleLowerCase()) || s.esporadico);
          }
          if (filtroNome) {
            resultFilter = resultFilter.filter(s => removeAccents(s.name).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroNome).toLocaleLowerCase()) || s.esporadico);
          }
          if (filtroCPF) {
            resultFilter = resultFilter.filter(s => removeAccents(s.document).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroCPF).toLocaleLowerCase()) || s.esporadico);
          }
          if (filtroMatricula) {
            resultFilter = resultFilter.filter(s => removeAccents(s.registry).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroMatricula).toLocaleLowerCase()) || s.esporadico);
          }
          if (filtroAplicativo) {
            resultFilter = resultFilter.filter(s => removeAccents(s.statusApp).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroAplicativo).toLocaleLowerCase()) || s.esporadico);
          }
          if (filtroPesquisa) {
            resultFilter = resultFilter.filter(s => {
              return (
                s.colaboradorId.toLocaleString().toLocaleLowerCase().includes(filtroPesquisa) ||
                removeAccents(s.nome).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                removeAccents(s.documento).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                removeAccents(s.matricula).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase()) ||
                removeAccents(s.statusApp).toLocaleString().toLocaleLowerCase().includes(removeAccents(filtroPesquisa).toLocaleLowerCase())
                );
              });
            }
          }
          return resultFilter;
        }


}
